/*
	Generated on 29/04/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.9.0
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import PilihProgramStudiPage from './containers/PilihProgramStudiPage'

const pilihProdiRoutes = [
{ 
	path: "/pilihprodi",
	element: <PilihProgramStudiPage />,
}

	

]

export default pilihProdiRoutes
